import { IToolDroppedEventsArgs } from './DragDropManager';
import { EventEmitter, EVENTS } from './store/EventEmitter';
import { Layer } from './types';
import { StateManager } from './store/StateManager';

export class ViewportManager {
  private host: HTMLElement;
  private viewports: Map<string, HTMLElement> = new Map();
  private eventEmitter: EventEmitter<any> = EventEmitter.getInstance();
  private stateManager: StateManager = StateManager.getInstance();

  constructor(host: HTMLElement) {
    this.host = host;
    this.eventEmitter.subscribe(EVENTS.TOOL_DROPPED, (data: IToolDroppedEventsArgs) => {
      this.handleToolDropped(data);
    });
  }

  public createViewport(layer: Layer): void {
    const viewport = document.createElement('div');
    viewport.classList.add('viewport');
    viewport.dataset.layerName = layer.name;
    this.host.appendChild(viewport);
    this.viewports.set(layer.name, viewport);
  }

  // public renderLayer(layer: Layer): void {
  //   const viewport = this.viewports.get(layer.name);
  //   if (!viewport) return;

  //   const table = document.createElement('table');
  //   const viewportWidth = viewport.clientWidth;
  //   const viewportHeight = viewport.clientHeight;
  //   const cellWidth =  Math.floor( Math.max(viewportWidth, viewportHeight) / layer.cols);
  //   const cellHeight = Math.floor(Math.max(viewportWidth, viewportHeight) / layer.rows);
  //   for (let i = 0; i < layer.rows; i++) {
  //     const row = document.createElement('tr');
  //     for (let j = 0; j < layer.cols; j++) {
  //       const cell = document.createElement('td');
  //       cell.dataset.row = i.toString();
  //       cell.dataset.col = j.toString();
  //       cell.style.width = `${cellWidth}px`;
  //       cell.style.height = `${cellHeight}px`;
  //       row.appendChild(cell);
  //     }
  //     table.appendChild(row);
  //   }
  //   viewport.innerHTML = '';
  //   viewport.appendChild(table);
  // }

  // public renderLayer(layer: Layer): void {
  //   const viewport = this.viewports.get(layer.name);
  //   if (!viewport) return;
  
  //   // Clear the viewport and create a canvas element
  //   viewport.innerHTML = '';
  //   const canvas = document.createElement('canvas');
  //   const viewportWidth = viewport.clientWidth;
  //   const viewportHeight = viewport.clientHeight;
  //   canvas.width = viewportWidth;
  //   canvas.height = viewportHeight;
  
  //   const context = canvas.getContext('2d');
  //   if (!context) return;
  
  //   // Calculate cell dimensions
  //   const cellWidth = Math.floor(Math.max(viewportWidth, viewportHeight) / layer.cols);
  //   const cellHeight = Math.floor(Math.max(viewportWidth, viewportHeight) / layer.rows);
  
  //   // Draw the grid
  //   context.strokeStyle = '#000'; // Grid line color
  //   context.lineWidth = 1;
  
  //   for (let i = 0; i <= layer.rows; i++) {
  //     const y = i * cellHeight;
  //     context.beginPath();
  //     context.moveTo(0, y);
  //     context.lineTo(viewportWidth, y);
  //     context.stroke();
  //   }
  
  //   for (let j = 0; j <= layer.cols; j++) {
  //     const x = j * cellWidth;
  //     context.beginPath();
  //     context.moveTo(x, 0);
  //     context.lineTo(x, viewportHeight);
  //     context.stroke();
  //   }
  
  //   // Append the canvas to the viewport
  //   viewport.appendChild(canvas);
  // }
  
  public renderLayer(layer: Layer): void {
    const viewport = this.viewports.get(layer.name);
    if (!viewport) return;
  
    // Clear the viewport
    viewport.innerHTML = '';
  
    // Create a single div to represent the grid
    const grid = document.createElement('div');
    grid.style.position = 'relative';
    grid.style.width = '100%';
    grid.style.height = '100%';
    grid.style.backgroundImage = `
      linear-gradient(to right, #ccc 1px, transparent 1px),
      linear-gradient(to bottom, #ccc 1px, transparent 1px)
    `;
    grid.style.backgroundSize = `${100 / layer.cols}% ${100 / layer.rows}%`;
    grid.style.boxSizing = 'border-box';
    grid.style.border = '1px solid black'; // Optional: border around the grid
  
    // Append the single grid element to the viewport
    viewport.appendChild(grid);
  }
  
  public renderContainers(layer: Layer): void {
    const viewport = this.viewports.get(layer.name);
    if (!viewport) return;

    layer.containers.forEach(container => {
      const cell: HTMLTableCellElement = viewport.querySelector(`td[data-row="${container.row}"][data-col="${container.col}"]`) as HTMLTableCellElement;
      if (cell) {
        cell.colSpan = container.width;
        cell.rowSpan = container.height;
        let dropContainer = document.createElement("div");
        dropContainer.style.position = 'relative';
        dropContainer.style.height = '100%';
        dropContainer.style.width = '100%';
        dropContainer.style.background = 'lightgrey';
        cell.appendChild(dropContainer);
      }
    });
  }

  private handleToolDropped(data: IToolDroppedEventsArgs): void {
    const state = this.stateManager.getState();
    // Handle the tool drop event and update the state accordingly
  }
}
